<template>
    <div class="container-fluid p-0 dashboard">
        <div class="d-flex flex-row">
            <TheNavbar/>
            <TheSidebar/>
            <div class="dashboard__content container-fluid" id="dashboard">
                <div class="container pl-0 pr-0 pb-5">
                    <router-view/>
                </div>
            </div>
            <div class="backdrop"
                 :class="{in: isSidebarOpen}"
                 @click="closeSidebar">
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import TheNavbar from '../../components/TheNavbar';
import TheSidebar from '../../components/TheSidebar';
import store from '../../store/store';

export default {
  components: {
    TheNavbar,
    TheSidebar,
  },
  computed: {
    ...mapState({
      isSidebarOpen: (state) => state.sidebar.isSidebarOpen,
    }),
  },
  methods: {
    closeSidebar() {
      this.$store.commit('sidebar/isSidebarOpen', false);
    },
  },
  beforeRouteEnter: (to, from, next) => {
    store.dispatch('auth/dashboardGuard', to);
    next();
  },
};
</script>
